import ProductCard_1 from './components/type1/index';
import ProductCard_2 from './components/type2/index';
import ProductCard_3 from './components/type3/index';
import ProductCard_4 from './components/type4/index';
import ProductCard_5 from "./components/type5/index";
import { productData_1, productData_2, productData_3, productData_4, productData_5 } from './index.interface';

interface PropsType {
  productData: productData_1 | productData_2 | productData_3 | productData_4 | productData_5;
}

export default function ProductCardV2({ productData }: PropsType) {
  const { type } = productData;
  //首页营销通用商卡
  if (type === '1') {
    return <ProductCard_1 productData={productData as productData_1}></ProductCard_1>;
    //feed流、心愿单、浏览历史、落地页等
  } else if (type === '2') {
    return <ProductCard_2 productData={productData as productData_2}></ProductCard_2>;
    //搜推商卡新样式
  } else if (type === '3') {
    return <ProductCard_3 productData={productData as productData_3}></ProductCard_3>;
    //店铺商卡
  } else if (type === '4') {
    // @ts-ignore
    return <ProductCard_4 productData={productData as productData_4}></ProductCard_4>;
    //Best sellers 商卡5
  } else if (type === "5") {
    return <ProductCard_5 productData={productData as productData_5}></ProductCard_5>;
  } else {
    return null;
  }
}
